module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon2b.701c539c.png";